"use client";

import { useEffect, useRef } from "react";

export const PrivacyModuleView = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!containerRef.current) return;

        const script = document.createElement("script");
        script.src = "https://app.cortina-consult.com/media/public/iframe-widget.min.js?v=1.1.7";
        script.async = true;
        script.setAttribute("data-policy", "67e25c76a1ab1");

        // Append script inside the specific div
        containerRef.current.appendChild(script);

        return () => {
            // Clean up script on unmount
            // eslint-disable-next-line react-hooks/exhaustive-deps
            containerRef.current?.removeChild(script);
        };
    }, []);

    return <div ref={containerRef} />;
};
